import React from "react";
import { ModalBuilder, Modal } from "@redriver/cinnamon";

const MakeInitialScheduleTermLiveModal = ({
  itemId,
  onSubmitted,
  reference,
  makeLiveAction,
  dealerId,
  ...props
}) => {
  return (
    <ModalBuilder
      submitAction={makeLiveAction}
      submitParams={{ id: itemId, dealerId }}
      onSubmitted={onSubmitted}
      renderTrigger={(showModal) => (
        <div {...props} onClick={showModal} className="item">
          Live
        </div>
      )}
      renderModal={(modalProps) => (
        <Modal.Confirmation {...modalProps} header={`Make Live: ${reference}`}>
          Are you sure you want to make
          {` ${reference} Live? This will cause any current live version to be replaced.`}
        </Modal.Confirmation>
      )}
    />
  );
};

export default MakeInitialScheduleTermLiveModal;
